import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '@/components/ui/sidebar';
import {
  LayoutDashboard,
  CheckSquare,
  AlertTriangle,
  AlertCircle,
  Users,
  Server,
  Folder,
  BarChart3,
  Settings,
  Shield,
  ClipboardList,
} from 'lucide-react';

const navigationItems = [
  { title: 'Overview', url: '/dashboard', icon: LayoutDashboard },
  { title: 'Assets', url: '/assets', icon: Server },
  { title: 'Tasks', url: '/tasks', icon: ClipboardList },
  { title: 'Controls', url: '/controls', icon: CheckSquare },
  { title: 'Risks', url: '/risks', icon: AlertTriangle },
  { title: 'Incidents', url: '/incidents', icon: AlertCircle },
  { title: 'Suppliers', url: '/suppliers', icon: Users },
  { title: 'Evidence', url: '/evidence', icon: Folder },
  { title: 'Reports', url: '/reports', icon: BarChart3 },
  { title: 'Standards', url: '/standards', icon: Shield },
  { title: 'Settings', url: '/settings', icon: Settings },
];

export function AppSidebar() {
  const { state } = useSidebar();
  const { profile, organization } = useAuth();
  const location = useLocation();
  const currentPath = location.pathname;

  const isActive = (path: string) => currentPath === path;

  // Filter navigation based on user role
  const filteredNavigation = navigationItems.filter(item => {
    if (profile?.role === 'viewer') {
      return !['Settings'].includes(item.title);
    }
    return true;
  });

  return (
    <Sidebar className={state === 'collapsed' ? "w-14" : "w-60"}>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel className="text-xs font-semibold text-muted-foreground">
            {organization?.name || 'ComplyManager'}
          </SidebarGroupLabel>
          
          <SidebarGroupContent>
            <SidebarMenu>
              {filteredNavigation.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild isActive={isActive(item.url)} tooltip={item.title}>
                    <NavLink 
                      to={item.url} 
                      end
                      className="flex items-center gap-2 text-sidebar-foreground hover:text-sidebar-accent-foreground"
                    >
                      <item.icon className="h-4 w-4" />
                      {state !== 'collapsed' && <span>{item.title}</span>}
                    </NavLink>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}